import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class BootErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error('Skyrover IDE failed to start:', error, info.componentStack);
  }

  override render() {
    if (this.state.error) {
      return (
        <div
          style={{
            fontFamily: 'Inter, Segoe UI, sans-serif',
            padding: 24,
            maxWidth: 720,
            margin: '40px auto',
            lineHeight: 1.5,
          }}
        >
          <h1 style={{ color: '#990099', marginTop: 0 }}>Skyrover IDE failed to load</h1>
          <p>Something went wrong while starting the app in your browser.</p>
          <pre
            style={{
              background: '#f5f5f5',
              border: '1px solid #ddd',
              padding: 12,
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
            }}
          >
            {this.state.error.message}
          </pre>
          <p>
            Try a hard refresh (Ctrl+F5), use Chrome or Edge, or re-upload the latest{' '}
            <code>apps/web/dist</code> folder to your server.
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
